import { AppDispatch } from "../store"
import { setNotification } from "../store/toastNotifications"
import api, { API_PATHS } from "./api"

class EmployeeSettingsService {

  static async editEmployeeWorkTime(
    shiftId: number,
    workTimeStart: string,
    workTimeEnd: string,
    dispatch: AppDispatch
  ) {
    try {
      await api.post(API_PATHS.updateEmployeeWorkTime, null, { params: { shiftId, workTimeStart, workTimeEnd } })
    } catch (error: any) {
      dispatch(setNotification({ message: error.message }))
      throw new Error(error.message)
    }
  }

}

export default EmployeeSettingsService